import React, { FunctionComponent, useMemo } from 'react';
import { ContactsTableContainer } from './contacts-table-container';
import { ListContactsData } from 'generated/api-client';
import { useListContacts } from 'generated/api-client/@tanstack/react-query.gen';

type ContactsTableRepository = {
  queryFilters?: ListContactsData['query'];
  onSort?: (column: string, direction: string) => void;
};

export const ContactsTableRepository: FunctionComponent<
  ContactsTableRepository
> = ({ onSort, queryFilters }) => {
  const { data, isLoading, error } = useListContacts({
    query: queryFilters,
  });

  const contacts = useMemo(() => {
    if (!data?.contacts) {
      return [];
    }
    return data.contacts.map((contact) => ({
      ...contact,
      views: contact.views?.filter(
        (view) =>
          !queryFilters?.viewStatus || view.status === queryFilters?.viewStatus,
      ),
    }));
  }, [data?.contacts]);

  return (
    <ContactsTableContainer
      error={error}
      loading={isLoading}
      contacts={contacts}
      onSort={onSort}
      orderBy={{
        column: queryFilters?.orderByColumn ?? 'familyName',
        direction:
          queryFilters?.orderByDirection === 'ASC' ? 'ascending' : 'descending',
      }}
    />
  );
};
